module.exports = __webpack_public_path__ + "img/chromeIcon.54466ffc.svg";